import * as _ from 'lodash'
import serviceGateway from './serviceGateway';
import store, { getCollection, getModel, ModelCollection } from './store';
import * as globalActions from './actions';
import fiscalYearFactory from './models/fiscalYearModel';

// TODO: handle model.job.removed message

// NOTE: Action returns are only to allow tests to access the promise. DO NOT use return values in runtime code.
export const fetchFiscalYears = () => {
	return serviceGateway.fetchFiscalYears()
		.then(result => {
			if (result.fiscalYears) {
				const collection = getCollection({ collection: ModelCollection.fiscalYears });

				collection.withMutations(c => {
					_.forEach(result.fiscalYears, fy => {
						c.set(fy.key, fiscalYearFactory(fy));
					});
				});
			}
		})
		.catch(err => {
			globalActions.pushAlert({ type: 'warning', message: err.message || err, isCloseable: true });
		});
};

export const updateEmployeeGoal = params => {
	const jobStats = store().getIn(['viewState', 'searchResults', 'jobStats']);
	const employeeStats = jobStats && jobStats.aggregates.accountManager[params.employeeKey];

	if (employeeStats && jobStats.fiscalYear.year === params.year) {
		const employee = getModel({ collection: ModelCollection.employees, key: params.employeeKey });
		const newGoal = Number(employee.getProfileValue(`salesGoalFY${jobStats.fiscalYear.year}`, '0'));
		const currentGoal = employeeStats.sumGoal;
		const diff = newGoal - currentGoal;

		if (diff) {
			employeeStats.sumGoal += diff;
			jobStats.aggregates.sumGoal += diff;

			store().setIn(['viewState', 'searchResults', 'jobStats'], _.assign({}, jobStats));
		}
	}
};